import { HeaderTitleSizes } from '@/types/gql.generated';

// Multiplier applied to the (text-length-derived) header title font size so the
// author can nudge the title smaller/larger via the "Title size" control. Lives
// on the shared Title component, so any header that renders Title supports it;
// MEDIUM = 1 leaves existing headers untouched.
const HEADER_TITLE_SIZE_SCALE: Record<HeaderTitleSizes, number> = {
  [HeaderTitleSizes.Small]: 0.8,
  [HeaderTitleSizes.Medium]: 1,
  [HeaderTitleSizes.Large]: 1.25,
};

export const getHeaderTitleSizeScale = (
  size: HeaderTitleSizes | null | undefined
): number => HEADER_TITLE_SIZE_SCALE[size ?? HeaderTitleSizes.Medium];
